import {getToken} from "@/scripts/Common";
import {TopUpRotation} from "@/Enums";
import {useI18n} from "@/composables/useI18n";
import {useGratificationSettings} from "@/composables/useGratificationSettings";

const useWebchargeRotations = () => {
  const {
    gratificationSettings
  } = useGratificationSettings();

  const {
    t,
  } = useI18n();

  const rotations = [
    {id: TopUpRotation.None, value: t("rotations.none")},
    {id: TopUpRotation.Once, value: t("rotations.once")},
    {id: TopUpRotation.Monthly, value: t("rotations.monthly")},
    {id: TopUpRotation.Quarterly, value: t("rotations.quarterly")},
    {id: TopUpRotation.Yearly, value: t("rotations.yearly")},
  ];

  if(gratificationSettings.value.enabled){
    rotations.push({id: TopUpRotation.Gratification, value: t("rotations.gratification")});
  }

  return {
    rotations
  }
}

export {
  useWebchargeRotations
}
